import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as auth from '../auth';
import { ErrorService } from '../services/error.service';

@Component({
  selector: 'app-signout',
  templateUrl: './signout.component.html',
  styleUrls: ['./signout.component.css']
})
export class SignoutComponent implements OnInit {

  isButtonVisible = false;

  constructor(private router: Router, private errorService: ErrorService) { }

  async ngOnInit(): Promise<void> {
    this.isButtonVisible = !(await this.signOut());
  }

  async signOut(): Promise<boolean> {
    try {
      if (await auth.signOut()) {
        this.router.navigateByUrl('/account/signed-out');
        return true;
      }
      else {
        this.errorService.show('Sign-out failed', new Error('Popup canceled'));
        return false;
      }
    }
    catch (err) {
      console.error(err);
      return false;
    }
  }

}
